/// <summary>
/// SDK的入口API
/// </summary>

import Util from "@/Master/Util";
import {KitConst} from "./KitConst";
import KitLog from "./KitLog";
import GoogleTrack from "@/Fwk/Kit/GoogleTrack";
import KitCfg from "@/Fwk/Kit/KitCfg";
import {KitBehaviour} from "./KitBehaviour";
import {KitSp} from "./KitSp";
import {WebPlatform} from "./Platform/WebPlatform";
import {KitTrack} from "@/Fwk/Kit/Track/KitTrack";
import {KitAdjust} from "@/Fwk/Kit/Adjust/KitAdjust";
import {JsonData} from "@/Fwk/Kit/JsonData";
import {EventName, RecodeKey} from "@/Fwk/Kit/Track/TrackConst";
import DataMgr from "@/Fwk/DataMgr";

/// <author>xiexingwu</author>
export default class KitAPI {
    static IS_ANDROID: false;
    static IS_IOS = false;
    static IS_WEB = true;
    static IS_UNITY = !(KitAPI.IS_ANDROID || KitAPI.IS_IOS || KitAPI.IS_WEB);
    // static string persistentDataPath = Application.persistentDataPath;
    static dpi = "0";
    static _platform: IPlatform;
    private static HadInit: boolean = false;

    private static cofigAsset = "";
    private static cofig210Asset = "";
    static enterAppCount: number;

    public static Init(asset: string, asset210: string): void {
        if (KitAPI.HadInit) {
            if (KitLog.IsLog) KitLog.Log("重复初始化");
            return;
        }

        KitAPI.cofigAsset = asset;
        KitAPI.cofig210Asset = asset210;

        KitBehaviour.Init();

        KitSp.Init();

        this.trackALive();

        //1、统计初始化
        KitTrack.Init();

        //3、归因初始化
        KitAdjust.Init(()=>{
            //todo 归因回调
            KitTrack.TrackALive(EventName.ALIVE);
        });

        //初始化储存基础header配置
        let headerStr = DataMgr.getStorage(KitConst.header_str);
        if (!headerStr){
            headerStr = this.GetHeaderStr();
            DataMgr.setStorage(KitConst.header_str, headerStr);
        }

        KitAPI.HadInit = true;
    }

    private static trackALive(){
        this.enterAppCount = KitSp.GetInt('enter_app_count',0);
        this.enterAppCount += 1;
        KitSp.SetInt('enter_app_count', this.enterAppCount);
        KitSp.Apply();
        if (this.enterAppCount == 1){
            if (KitLog.IsLog) KitLog.Log("设备首次激活");
            KitTrack.TrackALive(EventName.ACTIVE);
        }
    }

    private static GetPlatForm(): IPlatform {
        if (KitAPI._platform == null) {
            KitAPI._platform = new WebPlatform();
        }
        return KitAPI._platform;
    }

    static IsNetworkOk(): boolean {
        return this.GetPlatForm().IsNetworkOk();
    }

    static isVpnConnected(): boolean {
        return this.GetPlatForm().isVpnConnected();
    }

    static isWifiProxy(): boolean {
        return this.GetPlatForm().isWifiProxy();
    }

    static GetNetworkType(): string {
        return KitAPI.GetPlatForm().GetNetworkType();
    }

    static GetConfig(): string {
        return KitCfg.jsonString;
    }


    private static _testConfig: string;

    static get testConfig(): string {
        if (KitAPI._testConfig) return KitAPI._testConfig;
        KitAPI._testConfig = KitAPI.GetPlatForm().GetTestConfig();
        // Debug.Log($"{KitLog.LogTag} tc  return  {_testConfig}");//这里不能用KitLog,防止递归
        return KitAPI._testConfig;
    }

    static _testConfigJson: JsonData;
    static get testConfigJson(): JsonData {
        if (!KitAPI._testConfigJson) {
            KitAPI._testConfigJson = new JsonData(null, KitAPI.testConfig);
        }
        return KitAPI._testConfigJson
    }

    static IsTest(key: string): boolean {
        return KitAPI.testConfigJson.OptBoolean(key);
    }

    static GetConfigAsset(): [boolean, string] {
        //测试文件
        const IsTest210 = KitAPI.IsTest("test210");
        const isTestProduct = KitAPI.GetPlatForm().IsTestProduct();
        const isTest = IsTest210 && isTestProduct;
        const platCfg = KitAPI.GetPlatForm().GetCfg();
        const asset = isTest ? KitAPI.cofig210Asset : KitAPI.cofigAsset;
        if (KitLog.IsLog) {
            KitLog.Log(`产品配置:测试文件:IsTest210=${IsTest210},打包配置:isTestProduct=${isTestProduct}`);
            if (asset == null && !platCfg) {
                KitLog.LogWarning(
                    "产品配置:配置为NULL,请检查确保已经调用:KitProxy.Init(cofigAsset,cofig210Asset)," +
                    "确保参数中传入配置参数是否为NULL。或者平台端是否提供外部配置config获取接口。");
            }
        }
        return [isTest, platCfg ? platCfg : asset];
    }

    static GetIpAddress(): string {
        return KitAPI.GetPlatForm().GetDeviceIpAddress();
    }

    static LocalCountry(): string {
        return "";
    }

    //一般用于广告 ID
    static get ADID(): string {
        return this.GetPlatForm().GetGAID();
    }

    static get UUID(): string {
        return Util.h5UUID;
    }

    /// <summary>
    /// 日期对象转时间戳，毫秒为单位
    /// </summary>
    /// <param name="date"></param>
    /// <returns></returns>
    public static GetNowSeconds(): number {
        return Util.localTimeStamp;
    }

    /// <summary>
    /// 日期对象转时间戳，毫秒为单位
    /// </summary>
    /// <param name="date"></param>
    /// <returns></returns>
    public static GetNowMills(): number {
        return Util.localTimeStampMill;
    }

    //应用版本号
    static get versionCode(): number {
        return  this.GetPlatForm().GetVersionCode();
    }

    static get versionName(): string {
        return this.GetPlatForm().GetVersionName();
    }

    static get appName(): string {
        return this.GetPlatForm().GetAppLabel();
    }

    static get packageName(): string {
        return this.GetPlatForm().GetPackageName();
    }

    static get country(): string {
        return this.GetPlatForm().GetCountryCode();
    }

    static get language(): string {
        return this.GetPlatForm().GetLanguage();
    }

    private static _firstActiveTime: number;

    static get firstActiveTime(): number {
        if (this._firstActiveTime != 0) return this._firstActiveTime;
        const ls = DataMgr.getStorage(KitConst.actvite_time);
        let time = +ls;
        if (!isNaN(time)) {
            time = this.GetNowMills();
            DataMgr.setStorage(KitConst.actvite_time,time);
        }
        this._firstActiveTime = time;
        return this._firstActiveTime;
    }

    //激活天数
    static GetActiveDay(): number {
        const nowMills = this.GetNowMills();
        let days = 1;
        if (nowMills <= this.firstActiveTime) {
            return days; //当头，或者调时间到前面
        }

        days = (nowMills - this.firstActiveTime) / (24 * 60 * 60 * 1000);
        days++;

        if (days < 1) days = 1;

        return days;
    }

    //激活小时
    static GetActiveHours(): number {
        const nowMills = this.GetNowMills();
        let hours = 1;
        if (nowMills <= this.firstActiveTime) {
            return hours; //当头，或者调时间到前面
        }
        hours = (nowMills - this.firstActiveTime) / (60 * 60 * 1000);
        hours++;
        if (hours < 1) hours = 1;
        return hours;
    }

    private static _firstActiveVersionCode: number;

    static get firstActiveVersionCode(): number {
        if (this._firstActiveVersionCode != 0) return this._firstActiveVersionCode;
        this._firstActiveVersionCode = DataMgr.getStorage("firstActiveVersionCode") || 0;
        if (this._firstActiveVersionCode == 0) {
            this._firstActiveVersionCode = this.versionCode;
            DataMgr.setStorage("firstActiveVersionCode", this._firstActiveVersionCode)
        }
        return this._firstActiveVersionCode;
    }

    static get osVersion(): string {
        return this.GetPlatForm().GetOsVersion();
    }

    //获取浏览器类型
    static get osBrand(): string {
        return this.GetPlatForm().GetOsBrand();
    }



    static get osModel(): string {
        return  this.GetPlatForm().GetOsModel();
    }

    private static _deviceType: string;

    static get deviceType(): string {
        if (this._deviceType != null) return this._deviceType;
        this._deviceType = (this.osBrand + " " + this.osModel).trim();
        if (this._deviceType == " ") this._deviceType = "";
        return this._deviceType;
    }

    private static _osType: string;

    static get osType(): string {
        if (this._osType != null) return this._osType;
        if (this.IS_ANDROID) this._osType = KitConst.android;
        else if (this.IS_IOS) this._osType = KitConst.IOS;
        else if (this.IS_WEB) this._osType = KitConst.android;
        else this._osType = KitConst.android;
        return KitConst.android;
    }

    private static _osIntType = -1;

    static get osIntType(): number {
        if (this._osIntType != -1) return this._osIntType;
        if (this.IS_ANDROID) this._osIntType = 1;
        else if (this.IS_IOS) this._osIntType = 2;
        // else if (IS_WEB) this._osIntType = 3;
        else if (this.IS_WEB) this._osIntType = 1;
        else this._osIntType = 0;
        return this._osIntType;
    }

    static get userId(): number {
        return this.GetPlatForm().GetUserId();
    }

    static get isUpdateUser(): boolean {
        return this.firstActiveVersionCode != this.versionCode;
    }

    public static isUserBuy(): boolean {
        if (this.IsTest(KitConst.userBuy)) {
            return true;
        }
        return KitAdjust.IsBuyUserFlag();
    }

    public static GoogleGTMEvent(name: string, jsonStr: string) {
        return this.GetPlatForm().GoogleGTMEvent(name, jsonStr);
    }

    public static GetHeaderStr(): string {
        return  JSON.stringify(this.GetHeader().jObject);
    }

    public static GetHeader(): JsonData {
        const head = new JsonData();
        head.put(KitConst.UUID, this.UUID);
        head.put(KitConst.PACKAGE_NAME, this.packageName);
        head.put(KitConst.OS_LANGUAGE, this.language);
        head.put(KitConst.COUNTRY, this.country);
        head.put(KitConst.SCREEN_HEIGHT, window.innerHeight);
        head.put(KitConst.SCREEN_WIDTH, window.innerWidth);
        head.put(KitConst.VERSION_NAME, this.versionName);
        head.put(KitConst.VERSION_CODE, this.versionCode);
        head.put(KitConst.OS_VERSION, this.osVersion);
        head.put(KitConst.OS, this.osType);
        head.put(KitConst.PHONE_MODEL, this.deviceType);
        head.put(KitConst.ANDROID_ID, this.UUID);
        head.put(KitConst.GOOGLE_AID, this.ADID);
        const smID = this.GetSmID();
        if (!smID) head.put(KitConst.TP_DEVICE_ID, smID); //数盟ID
        head.put(KitConst.IS_UPGRADE_USER, this.isUpdateUser);
        head.put(KitConst.NET, this.GetNetworkType());
        head.put(KitConst.INSTALL_DAYS, this.GetActiveDay());
        head.put(KitConst.INSTALL_HOURS, this.GetActiveHours());
        head.put(KitConst.PRODUCT_ID, KitCfg.productId);
        head.put(KitConst.RELEASE_PRODUCT_ID, KitCfg.releaseProductId);
        const mediaSource = KitAdjust.GetDistributor();
        head.put(KitConst.CHANNEL, mediaSource);
        head.put(KitConst.MEDIA_SOURCE, mediaSource);
        head.put(KitConst.CAMPAIGN, KitAdjust.GetSecondDistributor());
        head.put(KitConst.ADSET, KitAdjust.GetCreative());
        head.put(KitConst.ADGROUP, KitAdjust.GetAdGroup());
        head.put(RecodeKey.H5_HOST_NAME, KitAPI.WebHotName);
        head.put(RecodeKey.H5_CHANNEL_QID, KitAdjust.h5ChannelQid);
        return head;
    }

    public static GetSmID(): string {
        return this.GetPlatForm().GetSMID()
    }

    public static get WebHotName(): string {
        return KitCfg.OptString("h5_host_name");
    }


}